import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ReportsFilter',
    standalone: false,
})
export class ReportsFilterPipe implements PipeTransform {
    transform(items: any[], searchText: string): any[] {
        if (!items || !searchText) {
            return items;
        }
        searchText = searchText.toLowerCase();
        const reports = [];
        items.forEach(it => {
            const chains = this.filterItems(it, searchText);
            reports.push(chains);
        });
        return reports;
    }

    filterItems = (it: any, searchText: string) => {
        const organizationObject = {
            ...it,
            chains: it.chains.filter(chain => chain.displayName.toLowerCase().includes(searchText)),
        };
        return organizationObject;
    };
}
